const { BonnetModule } = require('@bonnet/next/modules')

module.exports = {
    Module: BonnetModule,
};